import request from '@/utils/request'


// 查询联盟提现记录列表
export function listUnionWithdrawalRecord(query) {
  return request({
    url: '/union/union/withdrawal/record/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询联盟提现记录分页
export function pageUnionWithdrawalRecord(query) {
  return request({
    url: '/union/union/withdrawal/record/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询联盟提现记录详细
export function getUnionWithdrawalRecord(data) {
  return request({
    url: '/union/union/withdrawal/record/detail',
    method: 'get',
    params: data
  })
}

// 新增联盟提现记录
export function addUnionWithdrawalRecord(data) {
  return request({
    url: '/union/union/withdrawal/record/add',
    method: 'post',
    data: data
  })
}

// 修改联盟提现记录
export function updateUnionWithdrawalRecord(data) {
  return request({
    url: '/union/union/withdrawal/record/edit',
    method: 'post',
    data: data
  })
}

// 删除联盟提现记录
export function delUnionWithdrawalRecord(data) {
  return request({
    url: '/union/union/withdrawal/record/delete',
    method: 'post',
    data: data
  })
}
